import React from "react";
import classnames from "classnames";
import ReactSwitch from "react-switch";
import { HeartIcon } from "@aureskonnect/react-ui";
import { useSnapshot } from "valtio";
import { Tooltip } from "@mui/material";
import { useTranslation } from "react-i18next";

import {
    setActiveLanguages,
    store as generalSettingStore,
    setLanguageFavored,
} from "../store";

import ErrorToast from "@components/Common/ErrorTost";

type CustomIconsAssociateModalType = {
    e: any;
    isArchivedLanguagesClicked: boolean;
};

export function CustomIconsAssociateModal({
    e,
    isArchivedLanguagesClicked,
}: CustomIconsAssociateModalType) {
    const { t } = useTranslation();
    const { localShop, associatedLanguages, languageFavored } = useSnapshot(
        generalSettingStore
    );

    const [languageState, setLanguageState] = React.useState<boolean>(
        localShop.length === 1 &&
            associatedLanguages.findIndex(
                (el: any) => el.Id === e.selectedRow.Id
            ) !== -1
            ? associatedLanguages[
                  associatedLanguages.findIndex(
                      (el: any) => el.Id === e.selectedRow.Id
                  )
              ].isActive
            : true
    );

    React.useEffect(() => {
        setActiveLanguages({
            Id: e.selectedRow.Id,
            state: languageState,
        });
        // eslint-disable-next-line
    }, [languageState]);

    React.useEffect(() => {
        localShop.length === 1
            ? setLanguageFavored({
                  id: e.selectedRow.Id,
                  status:
                      associatedLanguages.findIndex(
                          (el: any) => el.Id === e.selectedRow.Id
                      ) !== -1
                          ? associatedLanguages[
                                associatedLanguages.findIndex(
                                    (el: any) => el.Id === e.selectedRow.Id
                                )
                            ].isFavorite
                          : false,
              })
            : setLanguageFavored({
                  id: e.selectedRow.Id,
                  status: false,
              });
    }, [associatedLanguages, e.selectedRow.Id, localShop]);

    return (
        <React.Fragment>
            {e.selectedRow?.subRows === undefined ? (
                <div className="d-flex justify-content-around">
                    <Tooltip
                        title={
                            languageFavored.find(
                                (el: any) => el.id === e.selectedRow.Id
                            ) !== undefined &&
                            languageFavored.find(
                                (el: any) => el.id === e.selectedRow.Id
                            ).status
                                ? ""
                                : t("Enable favorite state")
                        }
                    >
                        <div>
                            <HeartIcon
                                onClick={() => {
                                    if (
                                        !(
                                            languageFavored.find(
                                                (el: any) =>
                                                    el.id === e.selectedRow.Id
                                            ) !== undefined &&
                                            languageFavored.find(
                                                (el: any) =>
                                                    el.id === e.selectedRow.Id
                                            ).status
                                        ) &&
                                        languageState === false
                                    ) {
                                        ErrorToast(
                                            t(
                                                "Please note, you cannot activate the favorite state for a disabled language"
                                            )
                                        );
                                    } else {
                                        setLanguageFavored({
                                            id: e.selectedRow.Id,
                                            status:
                                                languageFavored.find(
                                                    (el: any) =>
                                                        el.id ===
                                                        e.selectedRow.Id
                                                ) !== undefined &&
                                                !languageFavored.find(
                                                    (el: any) =>
                                                        el.id ===
                                                        e.selectedRow.Id
                                                ).status,
                                        });
                                    }
                                }}
                                height={25}
                                width={25}
                                name="heart"
                                fill={
                                    languageFavored.find(
                                        (el: any) => el.id === e.selectedRow.Id
                                    ) !== undefined &&
                                    languageFavored.find(
                                        (el: any) => el.id === e.selectedRow.Id
                                    ).status
                                        ? "red"
                                        : "black"
                                }
                                className={`${classnames(
                                    "pointer__clz lan_icn_AFlike",
                                    {
                                        "not-allowed-icon__clz": isArchivedLanguagesClicked,
                                    }
                                )}`}
                            />
                        </div>
                    </Tooltip>
                    <Tooltip
                        title={
                            languageState === false
                                ? t("Activate")
                                : t("Unactivate")
                        }
                    >
                        <div>
                            <ReactSwitch
                                uncheckedIcon={false}
                                checkedIcon={false}
                                handleDiameter={26}
                                offColor="#f7b4b8"
                                offHandleColor="#E30613"
                                checked={languageState}
                                onChange={async () => {
                                    if (
                                        languageFavored.find(
                                            (el: any) =>
                                                el.id === e.selectedRow.Id
                                        ) !== undefined &&
                                        languageFavored.find(
                                            (el: any) =>
                                                el.id === e.selectedRow.Id
                                        ).status
                                    ) {
                                        ErrorToast(
                                            t(
                                                "Please note, you cannot deactivate a favorite language"
                                            )
                                        );
                                    } else setLanguageState(!languageState);
                                }}
                                onColor="#c2eddd"
                                onHandleColor="#34C38F"
                                width={50}
                                height={20}
                                className={`${classnames(
                                    "pointer__clz lan_icn_AFenableDisable ml-3",
                                    {
                                        "not-allowed-icon__clz": isArchivedLanguagesClicked,
                                    }
                                )}`}
                            />
                        </div>
                    </Tooltip>
                </div>
            ) : null}
        </React.Fragment>
    );
}
